<template>
  <v-container>
    <v-card class="dt-border pad-10" flat>
      <v-container>
        <v-row class="pa-5 mb-5">
          <div>
            <h2>Wallet Withdrawals</h2>
          </div>
          <v-spacer></v-spacer>
            <v-form class="d-flex" @submit.prevent="name ? reload() : ''">
            <v-text-field prepend-inner-icon="mdi-magnify" outlined dense :clearable="true" rename v-model="name"
              placeholder="First name or last name" />
            <v-btn class="ml-5" @click="name ? reload() : ''" color="primary" depressed>Search</v-btn>
          </v-form>
          <v-spacer></v-spacer>
          <div>
            <!-- <store-modal @reload = "reload"></store-modal> -->
            <v-select
            :items="items"
            v-model="value"
            item-text="text"
            item-value="key"
            @change="reload()"
            return-object
            dense
            filled
            rounded
            color="#F36F2E"
            style="border-radius:5px !important;width:250px"
            ></v-select>
          </div>
        </v-row>
        <v-row class="pl-5">
          <div>
            <span v-if="details.total != 0 && this.loading == false" class="dt-orange white--text pa-2 rounded">{{details.total}} transactions</span>
          </div>
          <v-spacer></v-spacer>
          <dtunes-pagination
            @nextPage="pageChangeHandle('next')"
            @previousPage="pageChangeHandle('previous')"
            @reload="reload"
            :rows="rows"
            :limit="limit"
            :page="page"
            :totalPage="totalPage"
          />
        </v-row>
        <br><br>
        <dtunes-loader :loading="loading"></dtunes-loader>
        <withdrawals-table :details="details" @reload="reload"></withdrawals-table>
        <dtunes-empty v-if="details.total == 0 && this.loading == false">
          <template v-slot:title>
            No {{ value.text }} Transaction
          </template>
          <template v-slot:sub-title>
            <!-- Click on the create New Store button to create a Store -->
          </template>
        </dtunes-empty>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
// ============= IMPORT COMPONENTS ===========
import DtunesLoader from "@/components/dtunes-loader.vue"
import DtunesEmpty from "@/components/dtunes-empty.vue"
import WithdrawalsTable from "../components/withdrawals-table.vue"
import DtunesPagination from "@/components/dtunes-pagination.vue"


// ========== IMPORT SERVICES =========
import { WalletService } from '@/services'
import { WithdrawalStatusEnum } from '@/enums'

export default {
    components:{
        DtunesLoader,
        DtunesEmpty,
        WithdrawalsTable,
        DtunesPagination
    },
    data : () => ({
        details : {},
        loading:false,
        items:[
            {
                text : 'All',
                key: '',
            },
            {
                text : 'Pending',
                key: WithdrawalStatusEnum.Pending
            },
            {
                text : 'Queued',
                key: WithdrawalStatusEnum.Queued
            },
            {
                text : 'Processing',
                key: WithdrawalStatusEnum.Processing
            },
            {
                text : 'Completed',
                key: WithdrawalStatusEnum.Completed
            },
            {
                text : 'Failed',
                key: WithdrawalStatusEnum.Failed
            },
            {
                text : 'Declined',
                key: WithdrawalStatusEnum.Declined
            },
            {
                text : 'Refunded',
                key: WithdrawalStatusEnum.Refunded
            },
        ],
        rows:[20,50,100],
        totalPage:0,
        limit:20,
        page:1,
        name: "",
        value:{
                text : 'All',
                key: ''
            },
    }),
    mounted(){
        this.getTransactions();
    },
    methods:{
        async getTransactions(){
            try {
                this.loading = true;
                const data = await WalletService.listWithdrawals({
                    page : this.page,
                    limit : this.limit,
                    filters:{
                        status : this.value.key
                    },
                    search: this.name
                })
                this.loading = false;
                this.details = data;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
            this.totalPage = Math.ceil(this.details.total / this.limit)
        },
        async reload(value){
            this.page = 1;
            if(value){
              this.limit = value
            }
            await this.getTransactions();
        },
        async pageChangeHandle(value) {
          switch (value) {
            case 'next':
              this.page += 1
              break
            case 'previous':
              this.page -= 1
              break
            default:
              this.page = value
          }
          this.getTransactions();
        }
    }
}
</script>